/** Человеческий текст ошибки облака (код — только в скобках). */
export function httpErrorText(action: string, status: number): string {
  if (status === 401) {
    return 'Сеанс облака истёк — войдите в «Интеграциях» заново'
  }
  if (status === 403) {
    // Не путать с истёкшей сессией: токен есть, но прав (роли) не хватает.
    return 'Нет прав: нужен вход директора (облачная учётная запись администратора)'
  }
  if (status === 404) {
    return `${action}: не найдено в облаке`
  }
  if (status >= 500) return 'Сервис облака временно недоступен — повторите позже'
  return `${action}: не удалось (код ${status})`
}

/** Убрать из текста ошибки ККТ внутренние формулировки агента. */
export function humanizeFiscalError(msg: string): string {
  if (/кассов\w* агент не подключен/i.test(msg)) {
    return 'Нет связи с кассой. Проверьте, что программа оборудования запущена'
  }
  return msg
}
